import { render, staticRenderFns } from "./PaymentDetailComponent.vue?vue&type=template&id=4ae33a6e&scoped=true"
import script from "./PaymentDetailComponent.vue?vue&type=script&lang=js"
export * from "./PaymentDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailComponent.vue?vue&type=style&index=0&id=4ae33a6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae33a6e",
  null
  
)

export default component.exports